<template>
  <div class="sp-hero-slideshow-navigation-item" :class="classModifiers" :style="cssProperties">
    <div class="sp-hero-slideshow-navigation-item__indicator-container">
      <div class="sp-hero-slideshow-navigation-item__indicator"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { booleanAttribute, toBoolean } from "#ce/utils/props";

const props = defineProps({
  active: booleanAttribute(),
  interval: {
    type: Number,
    required: true,
  },
});

const active = computed(() => toBoolean(props.active));

const classModifiers = computed(() => ({
  "--active": active.value,
}));

const cssProperties = computed(() => ({
  "--transition-duration": `${props.interval}ms`,
  "--transition-duration-shrink": "100ms",
}));
</script>

<style>
:host {
  display: block;
}
</style>

<style scoped lang="scss">
.sp-hero-slideshow-navigation-item {
  --indicator-active-width: var(--sp-comp-hero-slideshow-navigation-item-indicator-active-width, 24px);
  --indicator-size: var(--sp-comp-hero-slideshow-navigation-item-indicator-size, var(--sp-ref-spacing-4));
  --indicator-radius: var(--sp-comp-hero-slideshow-navigation-item-indicator-radius, calc(var(--indicator-size) / 2));
  cursor: pointer;

  &__indicator-container {
    position: relative;
    width: var(--indicator-size);
    height: var(--indicator-size);
    border-radius: calc(var(--indicator-size) / 2);
    background: rgba(255, 255, 255, 0.6);
  }

  &__indicator {
    position: relative;
    width: var(--indicator-size);
    height: var(--indicator-size);
    border-radius: var(--indicator-radius);
    background: white;
    transition: width var(--transition-duration-shrink, 0ms) ease;
  }

  &.--active {
    .sp-hero-slideshow-navigation-item__indicator {
      width: var(--indicator-active-width);
      border-radius: var(--indicator-radius);
      transition: width var(--transition-duration, 3000ms) ease;
    }
    .sp-hero-slideshow-navigation-item__indicator-container {
      width: var(--indicator-active-width);
    }
  }

  &:hover {
    .sp-hero-slideshow-navigation-item__indicator {
      outline: var(--sp-comp-hero-slideshow-navigation-item-indicator-hover-outline-width, 1px) solid
        rgba(255, 255, 255, 0.6);
      outline-offset: var(--sp-comp-hero-slideshow-navigation-item-indicator-hover-outline-offset, 2px);
    }
  }
}
</style>
